import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";
import SubHeader, {
  SubHeaderProps,
} from "components/blocks/subheader/SubHeader";
import styled from "styled-components";

interface Props extends SubHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const TableTemplate = ({ children, className, ...rest }: Props) => {
  return (
    <TableTemplateWrapper className={`table-template ${className}`}>
      <SubHeader {...rest} />
      <InnerPaddingWrapper className="table-template-content">
        {children}
      </InnerPaddingWrapper>
    </TableTemplateWrapper>
  );
};

const TableTemplateWrapper = styled.div`
  &.bg-container .table-template-content {
    background-color: ${({ theme }) =>
      theme.value === "light"
        ? `${theme.COLORS.WHITE}05`
        : theme.COLORS.WIDGETCOLOR};
    border-top: 1px solid
      ${({ theme }) =>
        theme.value === "light"
          ? theme.COLORS.LIGHTGRAYBORDER
          : theme.COLORS.PRIMARY3};
  }
`;
